module.exports = __webpack_public_path__ + "static/media/chickpea.cfae9f02.jpg";